import styled from 'styled-components';
import { borderColor, textColor, THEME_PRIMARY, THEME_RED, THEME_WARNING } from '../../styles/basics/colors';
import { TYPE_ERROR, TYPE_WARNING } from './toastNotification';

export const StNotification = styled.div<NotificationStyledProps>`
    display: flex;
    background-color: #fff;
    align-items: flex-start;
    min-width: 150px;
    ${props =>
        borderColor(
            props.type === TYPE_ERROR ? THEME_RED : props.type === TYPE_WARNING ? THEME_WARNING : THEME_PRIMARY
        )};
    border-style: solid;
    border-width: 1px;
    padding: 5px 7px;
    border-radius: 2px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.1);
    margin: 2px 2px 10px;
`;

interface NotificationStyledProps {
    type: string;
}

export const StNotificationText = styled.span<NotificationStyledProps>`
    margin-right: ${props => (props.type === TYPE_ERROR ? null : '20px')};
    flex-grow: 1;
    line-height: 18px;
`;

export const StNotificationIcon = styled.i<NotificationStyledProps>`
    ${props =>
        textColor(props.type === TYPE_ERROR ? THEME_RED : props.type === TYPE_WARNING ? THEME_WARNING : THEME_PRIMARY)};
    margin-right: 5px;
    font-size: 18px;
    line-height: 1 !important;
    flex-shrink: 0;
`;

export const StCloseIcon = styled.i`
    margin-left: 5px;
    font-size: 18px;
    line-height: 1 !important;
    cursor: pointer;
    flex-shrink: 0;
`;
